function getPublicBaseUrl() {
  // Keep this Jest/CRA-safe by avoiding import.meta syntax.
  return (
    (typeof process !== "undefined" && process.env.REACT_APP_PUBLIC_BASE_URL) ||
    (typeof window !== "undefined" && window.__PUBLIC_BASE_URL__) ||
    ""
  );
}

export function buildBookingUrl(user) {
  if (!user) return "";

  // 1) If a full link is already stored, use it.
  const stored =
    user?.publicBookingUrl || user?.bookingPageUrl || user?.bookingLink;
  if (stored) return stored;

  // 2) Decide base URL:
  // Prefer explicit env var; else use window origin,
  // but if running on localhost fall back to production host.
  const envBase = getPublicBaseUrl();

  let base =
    (envBase && envBase.replace(/\/$/, "")) ||
    (typeof window !== "undefined" ? window.location.origin : "");

  if (/localhost|127\.0\.0\.1/i.test(base) || base === "") {
    base = "https://groomsy.io"; // production host fallback
  }

  // 3) Pick a path segment for the user.
  const slug = user?.slug || user?.bookingSlug || user?.publicSlug || user?.uid;

  // 4) Build final URL.
  return `${base}/book/${slug || ""}`.replace(/\/$/, "");
}

export function buildClientRegistrationUrl(user) {
  if (!user) return "";

  const envBase = getPublicBaseUrl();

  let base =
    (envBase && envBase.replace(/\/$/, "")) ||
    (typeof window !== "undefined" ? window.location.origin : "");

  if (/localhost|127\.0\.0\.1/i.test(base) || base === "") {
    base = "https://groomsy.io";
  }

  const groomerId = user?.uid;
  return `${base}/register?g=${encodeURIComponent(groomerId || "")}`;
}
